import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__ml_asset_family, ENUM_UTILS__ml_asset_family } from '../+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__field_bundle_status } from './ENUM__field_bundle_status';
import { ENUM__field_kind } from './graph_invoke/_enums/ENUM__field_kind';
import { ENUM__field_store_interaction } from './graph_invoke/_fields/_base/_enums/ENUM__field_store_interaction';
import { ENUM__field_group_type } from './graph_invoke/_fields/_base/_methods/ENUM__field_group_type';
import { FIELD__base } from './graph_invoke/_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from './graph_invoke/_graph/DTO_GRAPH__instance';

export class DTO__generation_inputs_filter extends DTO__base {
  /*
   *
   */
  static _class_name_static: string = ENUM__dto_class_name.ABSTRACT;

  /*
   *
   */

  text!: string;
  //
  field_kind!: Set<ENUM__field_kind>;
  field_family!: Set<ENUM__ml_asset_family>;
  field_group_type!: Set<ENUM__field_group_type>;
  //

  is_readonly!: 'yes' | 'no' | 'all';
  is_has_effect_on_generation!: 'yes' | 'no' | 'all';
  is_shared_between_tools!: 'yes' | 'no' | 'all';
  is_only_sources!: 'yes' | 'no' | 'all';

  bundle_status!: ENUM__field_bundle_status;
  //

  /*
   *
   */
  constructor() {
    super();

    this.text = '';
    //
    this.field_kind = Object.values(ENUM__field_kind).to_set();
    this.field_family = ENUM_UTILS__ml_asset_family.get_families_for_filter().sort().to_set();
    this.field_group_type = Object.values(ENUM__field_group_type).sort().to_set();

    //
    this.is_readonly = 'no';
    this.is_only_sources = 'yes';
    this.is_has_effect_on_generation = 'all';
    this.is_shared_between_tools = 'all';
    this.bundle_status = ENUM__field_bundle_status.ALL;
  }

  /*
   *
   */

  filter__all<T extends FIELD__base>(fields: T[], graph: DTO_GRAPH__instance) {
    fields = this.filter__kind(fields);
    fields = this.filter__readonly(fields);
    fields = this.filter__sources(fields);
    fields = this.filter__has_effect_on_generation(fields, graph);
    fields = this.filter__shared_between_tools(fields);
    fields = this.filter__family(fields);

    return fields;
  }

  filter__family<T extends FIELD__base>(fields: T[]) {
    let out = fields.filter(field => this.field_family.has(field.meta.store__get_family()));

    return out;
  }

  filter__kind<T extends FIELD__base>(fields: T[]) {
    let out = fields.filter(field => this.field_kind.has(field.meta.field_kind));

    return out;
  }

  filter__shared_between_tools<T extends FIELD__base>(fields: T[]) {
    if (this.is_shared_between_tools == 'all') return fields;
    if (this.is_shared_between_tools == 'yes') return fields.filter(field => field.meta.store__interaction != ENUM__field_store_interaction.NONE);
    if (this.is_shared_between_tools == 'no') return fields.filter(field => field.meta.store__interaction == ENUM__field_store_interaction.NONE);

    return [];
  }

  filter__has_effect_on_generation<T extends FIELD__base>(fields: T[], graph: DTO_GRAPH__instance) {
    if (this.is_has_effect_on_generation == 'all') return fields;
    if (this.is_has_effect_on_generation == 'yes') return fields.filter(field => graph.node_and_field__has_effect_on_generation_runtime(field));
    if (this.is_has_effect_on_generation == 'no') return fields.filter(field => !graph.node_and_field__has_effect_on_generation_runtime(field));

    return [];
  }

  filter__sources<T extends FIELD__base>(fields: T[]) {
    if (this.is_only_sources == 'all') return fields;
    if (this.is_only_sources == 'yes') return fields.filter(field => !field.meta.data__is_linked);
    if (this.is_only_sources == 'no') return fields.filter(field => field.meta.data__is_linked);

    return [];
  }

  filter__readonly<T extends FIELD__base>(fields: T[]) {
    if (this.is_readonly == 'all') return fields;
    if (this.is_readonly == 'yes') return fields.filter(field => field.meta.ui__is_readonly);
    if (this.is_readonly == 'no') return fields.filter(field => !field.meta.ui__is_readonly);

    return [];
  }

  filter__bundle_status<T extends FIELD__base>(fields: T[], bundle_current: any, bundles_list: any[]) {
    if (this.bundle_status == 'all') return fields;

    return [];
  }
}
